<template>
	<div class="w-100 p-3 border-15 overflow-auto">
		<div class="row">
			<div class="col-12 d-flex algin-items-center">
				<div class="d-flex algin-items-center ml-3"><span class="status-6 ml-1">تعداد کل:</span><span class="status-6">{{flds.length}}</span></div>
				<div class="d-flex algin-items-center ml-3"><span class="status-12 ml-1">تعداد رد شده:</span><span class="status-12">{{flds.filter((fild) => fild.status == 12).length}}</span></div>
				<div class="d-flex algin-items-center ml-3"><span class="status-1 ml-1">تعداد فعال شده:</span><span class="status-1">{{flds.filter((fild) => fild.status == 1).length}}</span></div>
				<div class="d-flex algin-items-center"><span class="status-13 ml-1">تعداد در انتظار فعال سازی:</span><span class="status-13">{{flds.filter((fild) => fild.status == 13).length}}</span></div>
			</div>
			<div class="col-4">
				<header class="position-relative w-100 d-flex align-items-center justify-content-center mb-3 c-bg-warning">
					<h4 class="mb-2">در حال انجام</h4>
					<div class="position-absolute d-flex align-items-center justify-content-center badg" v-if="sortflds"><div class="d-flex align-items-center justify-content-center">{{ sortflds.filter((i) => i.start == 'true' && i.status != 13 && i.status != 12 && i.status != 1).length }}</div></div>
				</header>
				<ul class="d-flex flex-column w-100 p-3 bg-white">
					<li v-for="(f, i) in sortflds" :key="i" v-if="f.start == 'true' && f.status != 13 && f.status != 12 && f.status != 1" class="d-flex align-items-center flex-wrap p-3 item mb-2">
						<div class="w-100 d-flex align-items-center mb-2">
							<userImg :badge="false" :src="f.files" v-if="f.files" vStyle="border-radius: 50% !important; width: 40px !important; height:40px !important;" imgSize="40px" alt=""/>
							<span v-if="f.dattime" class="custom-font-style mr-2">تاریخ: {{ f.dattime }}</span>
						</div>

						<h3 v-if="f.fullname" class="text-black fullname">{{ f.fullname }}</h3>

						<div class="w-100 bg-white p-2 citem mb-2">
							<span class="custom-font-style">{{ f.phone }}</span>
						</div>

						<div v-if="f.status" class="w-100 bg-white p-2 citem">
							<span class="custom-font-style" :class="
								f.status == 0 
								? 'status-0' 
								: f.status == 7  ? 
								'status-7'
								: f.status == 10 ?
								'status-10'
								: f.status == 13 ?
								'status-13'
								: f.status == 11 ?
								'status-11'
								: f.status == 12 ?
								'status-12'
								: f.status == 3 ?
								'status-3'
								: f.status == 6 ?
								'status-6' 
								: f.status == 5 ?
								'status-5'
								: f.status == 2 ?
								'status-2'
								: f.status == 1 ?
								'status-1'
								: f.status
							">
								{{ 
									f.status == 0 
									? 'بدون احراز هویت' 
									: f.status == 7  ? 
									'ناقص با احراز هویت'
									: f.status == 10 ?
									'در انتظار بررسی مدارک'
									: f.status == 13 ?
									'در انتظار فعال سازی'
									: f.status == 11 ?
									'نقص مدارک ارزیابی'
									: f.status == 12 ?
									'رد شده'
									: f.status == 3 ?
									'بلاک شده'
									: f.status == 6 ?
									'درخواست تغییر یا ارتقا'
									: f.status == 5 ?
									'حذف شده'
									: f.status == 2 ?
									'پروفایل کامل/ غیرفعال/ ادمین'
									: f.status == 1 ?
									'فعال'
									: f.status
								}}
							</span>
						</div>
						<div class="w-100 bg-white p-2 mt-3 citem">
							<div v-if="f.followup" v-html="f.followup" class="custom-font-style mb-3"></div>
							<textareainput
								label = "توضیحات پیگیری"
								@blurinputTxtFunc = "(e)=>{val.followup = e; setfollowup(e, f.teacher_id);}"
								:value="val.followup"
							/>
						</div>
					</li>
				</ul>
			</div>
			<div class="col-4">
				<header class="position-relative w-100 d-flex align-items-center justify-content-center mb-3 c-bg-success">
					<h4 class="mb-2">انجام شده</h4>
					<div class="position-absolute d-flex align-items-center justify-content-center badg" v-if="flds"><div class="d-flex align-items-center justify-content-center">{{ flds.filter((i) => i.status == 13 || i.status == 12 || i.status == 1).length }}</div></div>
				</header>
				<ul class="d-flex flex-column w-100 p-3 bg-white">
					<li v-for="(f, i) in flds" :key="i" v-if="f.status == 13 || f.status == 12 || f.status == 1" class="d-flex align-items-center flex-wrap p-3 item mb-2">
						<div class="w-100 d-flex align-items-center mb-2">
							<userImg :badge="false" :src="f.files" v-if="f.files" vStyle="border-radius: 50% !important; width: 40px !important; height:40px !important;" imgSize="40px" alt=""/>
							<span v-if="f.dattime" class="custom-font-style mr-2">تاریخ: {{ f.dattime }}</span>
						</div>

						<h3 v-if="f.fullname" class="text-black fullname">{{ f.fullname }}</h3>

						<div class="w-100 bg-white p-2 citem mb-2">
							<span class="custom-font-style">{{ f.phone }}</span>
						</div>

						<div v-if="f.status" class="w-100 bg-white p-2 citem">
							<span class="custom-font-style" :class="
								f.status == 0 
								? 'status-0' 
								: f.status == 7  ? 
								'status-7'
								: f.status == 10 ?
								'status-10'
								: f.status == 13 ?
								'status-13'
								: f.status == 11 ?
								'status-11'
								: f.status == 12 ?
								'status-12'
								: f.status == 3 ?
								'status-3'
								: f.status == 6 ?
								'status-6' 
								: f.status == 5 ?
								'status-5'
								: f.status == 2 ?
								'status-2'
								: f.status == 1 ?
								'status-1'
								: f.status
							">
								{{ 
									f.status == 0 
									? 'بدون احراز هویت' 
									: f.status == 7  ? 
									'ناقص با احراز هویت'
									: f.status == 10 ?
									'در انتظار بررسی مدارک'
									: f.status == 13 ?
									'در انتظار فعال سازی'
									: f.status == 11 ?
									'نقص مدارک ارزیابی'
									: f.status == 12 ?
									'رد شده'
									: f.status == 3 ?
									'بلاک شده'
									: f.status == 6 ?
									'درخواست تغییر یا ارتقا'
									: f.status == 5 ?
									'حذف شده'
									: f.status == 2 ?
									'پروفایل کامل/ غیرفعال/ ادمین'
									: f.status == 1 ?
									'فعال'
									: f.status
								}}
							</span>
						</div>
						<div v-if="f.followup" class="w-100 bg-white p-2 mt-3 citem">
							<div v-if="f.followup" v-html="f.followup" class="custom-font-style mb-3"></div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import textareainput from  "../../UI/input/textareaInput.vue";
		import userImg from  "../../UI/userImg/userImg.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		export default {
			name: 'teachers_part1',
			data(){
				return {
					baseurl: window.baseurl,
					access_level:[
						'مدیر کل',
						'مدیر میانی',
						'کارشناس ارشد CRM',
						'کارشناس CRM',
						'کارشناس فروش',
						'کارشناس Marketing',
						'SEO',
						'مدیر مالی',
					],
					val:{
						followup: '',
					},
				}
			},
			components: {
				btn,
				pageNavigation,
				userImg,
				textareainput,
			},
			props: {
				flds: {
					default: [],
				},
				sortflds: {
					default: [],
				},
			},
			mounted(){
				this.flds.sort(function(a, b) {
					// Convert the date strings to Date objects
					let dateA = new Date(a.datestart);
					let dateB = new Date(b.datestart);

					// Subtract the dates to get a value that is either negative, positive, or zero
					return dateB - dateA;
				});
				// this.sortflds = this.flds;
				console.log('sortflds', this.flds.reverse() );
				this.sortflds = this.flds.reverse();
			},
			methods:{
				setPage(page){
					this.$emit('setPage', page);
				},
				changestart(teacher_id, THIS = this){
					window.$.post(this.baseurl+"crm/changestart", {
						role: this.$localStorage.get("user").username.role, 
						token: this.$localStorage.get("user"),
						start: true,
						teacher_id: teacher_id,
					}, function(D){
						if(D.status.code=="401"){
							THIS.$localStorage.remove('user');
							THIS.$router.push('/login');
						}else{
							if(D.data) {
								window.location.reload();
							}
						}
					}, "json");
				},
				setfollowup(followup, teacher_id, THIS = this){
					
					if(followup && followup.length > 5) {
						window.$.post(this.baseurl+"crm/followup", {
							role: this.$localStorage.get("user").username.role, 
							token: this.$localStorage.get("user"),
							followup: followup,
							teacher_id: teacher_id,
						}, function(D){
							if(D.status.code=="401"){
								THIS.$localStorage.remove('user');
								THIS.$router.push('/login');
							}else{
								if(D.data) {
									window.location.reload();
								}
							}
						}, "json");
					} else {
						console.log(followup);
					}
				},
			}
		}
	</script>
<style>
	.c-bg-danger {
		background-color: #F7E6E7;
		height: 65px;
		border-radius: 20px 20px 0 0;
	}
	.c-bg-danger h4 {
		color: #AA000C;
		font-size: 18px !important;
	}

	.c-bg-warning {
		background-color: #FFF7E9;
		height: 65px;
		border-radius: 20px 20px 0 0;
	}
	.c-bg-warning h4 {
		color: #FAA61A;
		font-size: 18px !important;
	}

	.c-bg-success {
		background-color: #EAF5F2;
		height: 65px;
		border-radius: 20px 20px 0 0;
	}
	.c-bg-success h4 {
		color: #25937C;
		font-size: 18px !important;
	}

	.item {
		background-color: #F5FAFD;
		border-radius: 15px;
	}
	.citem {
		border-radius: 10px;
	}
	.citem div {
		padding-top: 0px !important;
	} 
	
	.citem div > textarea {
		background-color: #A7A9AC !important;
		color: #fff !important;
	} 	
	.custom-font-style {
		font-size: 12px;
    	color: #676767;
	}
	.citem div > textarea::placeholder,
	.citem div > textarea::-ms-input-placeholder {
		color: #fff !important;
	}
	.fullname {
		font-size: 16px !important;
	}
	.boxbtnchangst span {
		cursor: pointer;
		display: flex;
		text-align: center;
		justify-content: center;
		align-items: center;
		background-color: #1b60c6;
		border-radius: 10px;
		color: #fff;
		font-size: 14px;
		height: 40px;
	}
	.badg {
		background-color: #fff;
		border-radius: 50%;
		width: 42px;
		height: 42px;
		bottom: -21px;
	}
	.badg div {
		border-radius: 50%;
		width: 38px;
		height: 38px;
		font-size: 12px;
		font-family: 'IRANYekan';
	}
	.c-bg-danger .badg div {
		background-color: #F7E6E7;
		color: #AA000C;
	}
	.c-bg-warning .badg div {
		background-color: #FFF7E9;
		color: #FAA61A;
	}
	.c-bg-success .badg div {
		background-color: #EAF5F2;
		color: #25937C;
	}

	.status-1 {
		color: #2AA78D !important;
	}
	.status-13 {
		color: #003143 !important;
	}
	.status-10 {
		color: #FBB033 !important;
	}
	.status-2 {
		color: #361AFA !important;
	}
	.status-7 {
		color: #1A6EFA !important;
	}	
	.status-0 {
		color: #A61AFA !important;
	}
	.status-11 {
		color: #FF7A00 !important;
	}
	.status-6 {
		color: #257393 !important;
	}
	.status-3 {
		color: #FA1A6E !important;
	}
	.status-12 {
		color: #AA000C !important;
	}
	.status-5 {
		color: #93253C !important;
	}
</style>
